export var checkIfAnyQuestsExists = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var quests = state.questInfo.quest;
    return quests && quests.length ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/insufficient-level/checkIfAnyQuestsExists.ts
// module id = 2348
// module chunks = 3